// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".osui-tooltip .ant-tooltip-content{box-shadow:var(--shadow-1)}.osui-tooltip .ant-tooltip-inner{min-height:var(--tooltip-min-height);padding:6px 8px;padding:var(--tooltip-inner-padding,6px 8px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
